import type { FoundersLoungeCatalog, FoundersLoungeArticleDetail } from '@doneverse/shared'
import { api } from '../api/index.js'

export const foundersLoungeService = {
  catalog: async (): Promise<FoundersLoungeCatalog> => {
    return api.get('/founders-lounge').json<FoundersLoungeCatalog>()
  },
  article: async (articleSlug: string): Promise<FoundersLoungeArticleDetail> => {
    return api.get(`/founders-lounge/${encodeURIComponent(articleSlug)}`).json<FoundersLoungeArticleDetail>()
  },
}
